export default {
  allowInToolbox: true,
  properties: {
    $ID: {
      name: 'vuetifyWidgets.dr-base.id',
      type: 'string'
    },
    UniqueName: {
      name: 'vuetifyWidgets.dr-base.uniqueName',
      type: 'string'
    },
    Class: {
      name: 'vuetifyWidgets.dr-base.cssClass',
      type: 'string',
      default: ''
    },
    Visible: {
      name: 'vuetifyWidgets.dr-base.visible',
      type: 'string',
      default: ''
    },
    HideOnMobile: {
      name: 'vuetifyWidgets.dr-base.hideOnMobile',
      type: 'boolean',
      default: false,
      enum: [{
        text: 'vuetifyWidgets.dr-base.hide',
        value: true
      },
      {
        text: 'vuetifyWidgets.dr-base.notHide',
        value: false
      }]
    },
    HideOnTablet: {
      name: 'vuetifyWidgets.dr-base.hideOnTablet',
      type: 'boolean',
      default: false,
      enum: [{
        text: 'vuetifyWidgets.dr-base.hide',
        value: true
      },
      {
        text: 'vuetifyWidgets.dr-base.notHide',
        value: false
      }]
    },
    HideOnPC: {
      name: 'vuetifyWidgets.dr-base.hideOnPC',
      type: 'boolean',
      default: false,
      enum: [{
        text: 'vuetifyWidgets.dr-base.hide',
        value: true
      },
      {
        text: 'vuetifyWidgets.dr-base.notHide',
        value: false
      }]
    }
  }
}
